module.exports = __webpack_public_path__ + "static/img/料车超挂告警.0274e109.png";